import React, {useState} from "react";
import MenuIcon from "@mui/icons-material/Menu";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {ContactModal} from "../ContactModal/ContactModal";
import {useRoutes} from "../../hooks";
import {ChangeLanguage} from "../ChangeLanguage/ChangeLanguage";

export default function ResponsiveMenu() {
  const {routes} = useRoutes();
  const [openContactModal, setOpenContactModal] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const {t} = useTranslation();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  if (!isSmallScreen) return null;

  const handleChangeModal = () => {
    setOpenContactModal(!openContactModal);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(prevState => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{textAlign: "center"}}>
      <Typography variant="h6" sx={{my: 2}} className="text-slate-200">
        Portfolio
      </Typography>
      <Divider />
      <List>
        {routes.length &&
          routes.map(route => (
            <ListItem key={route.name + "-burguermenu"} disablePadding>
              <ListItemButton className="p-0">
                {route.name === "Contact" ? (
                  <>
                    <button
                      onClick={handleChangeModal}
                      className="text-start w-full border-b-2 m-b-2 text-slate-200"
                    >
                      {t("navbar.contact")}
                    </button>
                    <ContactModal
                      openModal={openContactModal}
                      onChangeModal={setOpenContactModal}
                    />
                  </>
                ) : (
                  <Link
                    to={route.to || "/"}
                    className="text-start w-full border-b-2 text-slate-200"
                  >
                    <ListItemText primary={route.name} />
                  </Link>
                )}
              </ListItemButton>
            </ListItem>
          ))}

        <ListItem disablePadding>
          <ListItemButton>
            <ChangeLanguage
              language="en"
              classname="text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal
                          before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
                          before:bg-blue-400 before:transition-animationLineBefore 
                          hover:before:visible hover:before:w-6 hover:text-neutral-50 relative max-sm:ml-0 opacity-100 duration-[0.5s] ease-in-out"
            />
            <p style={{marginTop: "2px"}}>|</p>
            <ChangeLanguage
              language="es"
              classname=" text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal
                          before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
                          before:bg-blue-400 before:transition-animationLineBefore 
                          hover:before:visible hover:before:w-6 hover:text-neutral-50 relative max-sm:ml-0 opacity-100 duration-[0.2s] ease-in-out"
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{display: "flex"}}>
      <AppBar component="nav" sx={{backgroundColor: "#1715A0"}}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{mr: 2, display: {sm: "none"}}}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={openContactModal === false && mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: {xs: "block", sm: "none"},
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: "60%",
              backgroundColor: "#1715A0",
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}
